import Vue from 'vue';
function validate() {
  if (/^\d*$/.test(this.value)) {
    this.oldValue = this.value;
    this.oldSelectionStart = this.selectionStart;
    this.oldSelectionEnd = this.selectionEnd;
  } else if (this.hasOwnProperty('oldValue')) {
    this.value = this.oldValue;
    this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
  }
}
const events = [
  'input',
  'keydown',
  'keyup',
  'mousedown',
  'mouseup',
  'select',
  'contextmenu',
  'drop',
  'paste',
];
export default Vue.directive('input-only-numbers', {
  inserted(el) {
    events.forEach(eventName => {
      el.addEventListener(eventName, validate);
    });
  },
  unbind(el) {
    events.forEach(eventName => {
      el.removeEventListener(eventName, validate);
    });
  },
});
